<template>
  <div id="reportIndex">
    <!-- <el-row id="tableWarp"> -->
    <!-- <el-col :lg="24" :sm="24" :xs="24" class="card-panel-col"> -->
    <!-- 列表 -->
    <div style="position: relative;padding: 20px;">
      <!-- 删选 -->
      <div>
        <!-- 公司选择 -->
        <search-company v-model="selectCompany2" @change="changeSearch"></search-company>
        <el-input v-model="tableObj.deviceName" :placeholder="$t('AllDevices.SearchDeviceNameOrSn')" clearable
          @clear="changeSearch" style="width: auto; ">
          <el-button slot="append" icon="el-icon-search" @click="changeSearch()" />
        </el-input>
      </div>
      <el-tabs v-model="activeDevice" style="margin-top:15px;" type="border-card">
        <p v-if="!isShowYHUB&&!isShowLithium">{{ $t('yhubReport.Nodata') }}</p>
        <!-- yhub -->
        <el-tab-pane v-if="isShowYHUB" :label="$t('AllDevices.BatteryMonitor')" name="Yhub" style="position:relative;">
          <div v-if="isShowLoading" class="loading">
            <div class="el-icon-loading" style="font-size: 2em;" />
          </div>
          <el-table :data="yhubTableData" style="width: 100%" border class="myTable">
            <el-table-column prop="deviceName" align="center" :label="$t('dashboard.DeviceName')" min-width="20%" />
            <el-table-column :label="$t('report.TimeSelection')" align="center" min-width="34%">
              <template slot-scope="scope">
                <div>
                  <el-select v-model="scope.row.weekId" :placeholder="$t('report.TimeSelection')" class="filter-item"
                    filterable style="width:100%;padding-left: 10px;padding-right: 10px"
                    @change="changeSearchWeek(scope.row,scope.$index)">
                    <el-option v-for="(item,index) in scope.row.weekOptions" :key="index" :label="item.label"
                      :value="item.key" />
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="chargedah" align="center" :label="$t('report.TotalCharged')" min-width="12%" />
            <el-table-column prop="usedah" align="center" :label="$t('report.TotalDischarged')" min-width="12%" />
            <el-table-column prop="warningAccount" align="center" :label="$t('report.newWarnings')" min-width="12%" />
            <el-table-column prop="action" align="center" :label="$t('yhubReport.Operating')" min-width="10%">
              <template slot-scope="scope">

                <el-button v-if="scope.row.weekOptions.length" type="primary" size="mini" class="el-icon-view"
                  :title="$t('titles.toDetail')" @click="goToYhubDetail(scope.row,'yhub')" />
                <a v-if="scope.row.weekOptions.length" @click="goWeekReport(scope.row)">week</a>

              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination v-if="pageshow1" :page-size="listQuery1.pageInfo.limit"
                :page-sizes="listQuery1.pageInfo.pageList" :total="listQuery1.pageInfo.total" background
                current-page.sync="listQuery1.pageInfo.page" layout="total, sizes, prev, pager, next, jumper"
                @current-change="handleCurrentChange1" @size-change="handleSizeChange1" />
            </div>
          </div>
        </el-tab-pane>
        <!-- 锂电池 -->
        <el-tab-pane v-if="isShowLithium" :label="$t('AllDevices.LithiumBattery')" name="Lithium"
          style="position:relative;">
          <!-- <div v-if="isShowLoading" class="loading" /> -->
          <div v-if="isShowLoading" class="loading">
            <div class="el-icon-loading" style="font-size: 2em;" />
          </div>
          <el-table :data="lithiumTableData" style="width: 100%" border class="myTable">
            <el-table-column prop="deviceName" align="center" :label="$t('dashboard.DeviceName')" min-width="20%" />
            <el-table-column :label="$t('report.TimeSelection')" align="center" min-width="34%">
              <template slot-scope="scope">
                <div>
                  <el-select v-model="scope.row.weekId" :placeholder="$t('report.TimeSelection')" class="filter-item"
                    filterable style="width:100%;padding-left: 10px;padding-right: 10px"
                    @change="changeSearchWeek(scope.row,scope.$index)">
                    <el-option v-for="(item,index) in scope.row.weekOptions" :key="index" :label="item.label"
                      :value="item.key" />
                  </el-select>
                </div>
              </template>
            </el-table-column>
            <el-table-column prop="chargedah" align="center" :label="$t('report.TotalCharged')" min-width="12%" />
            <el-table-column prop="usedah" align="center" :label="$t('report.TotalDischarged')" min-width="12%" />
            <el-table-column prop="warningAccount" align="center" :label="$t('report.newWarnings')" min-width="12%" />
            <el-table-column prop="action" align="center" :label="$t('yhubReport.Operating')" min-width="10%">
              <template slot-scope="scope">

                <el-button v-if="scope.row.weekOptions.length>0" type="primary" size="mini" class="el-icon-view"
                  :title="$t('titles.toDetail')" @click="goToYhubDetail(scope.row,'lithium')" />

              </template>
            </el-table-column>
          </el-table>
          <!-- 列表模块————分页 -->
          <div style="background-color: white;width: 100%;border-radius: 0 0 10px 10px;">
            <div class="pagination-container">
              <el-pagination v-if="pageshow2" :page-size="listQuery2.pageInfo.limit"
                :page-sizes="listQuery2.pageInfo.pageList" :total="listQuery2.pageInfo.total" background
                current-page.sync="listQuery2.pageInfo.page" layout="total, sizes, prev, pager, next, jumper"
                @current-change="handleCurrentChange2" @size-change="handleSizeChange2" />
            </div>
          </div>
          <!-- </div> -->
        </el-tab-pane>
      </el-tabs>
    </div>
    <!-- </el-col> -->
    <!-- </el-row> -->
  </div>
</template>
<script>
import { findDeviceType } from '@/api/allDevice'
import { findBatteryDeviceWeekList, findLithiumDeviceWeekList } from '@/api/report'
import { getDateAndHour } from '@/utils/updateTime.js'
import { pagination } from '@/utils/init_table' // 分页
export default {
  name: 'DashboardAdmin',
  components: {

  },
  data () {
    return {
      // 分页1----start
      listQuery1: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow1: true,
      // 分页1----end
      // 分页2----start
      listQuery2: {
        deviceVersion: null,
        pageInfo: pagination(),
        q: ''
      },
      pageshow2: true,
      // 分页----end
      activeDevice: 'Yhub',
      isShowYHUB: true,
      isShowLithium: false,
      isShowLoading: true,
      yhubTableData: [],
      lithiumTableData: [],
      tableObj: {
        companyId: '',
        // deviceName: 'BMS6665' // 删选--设备名称/sn/mcuId
        deviceName: '' // 删选--设备名称/sn/mcuId
      },
      selectCompany: [],
      selectCompany2: []

    }
  },
  computed: {
    language () {
      return this.$store.state.language
    }
  },
  watch: {
    language () {
      this.changeSearch()
    },
    activeDevice (newValue, oldValue) {
      if (newValue == 'Yhub') this.yhubQueryList()
      if (newValue == 'Lithium') this.lithiumQueryList()
    }
  },
  mounted () {
    this.yhubQueryList()
    this.findDeviceType1()
  },
  methods: {
    goWeekReport (row) {
      console.log(row)
      const url = '/w/yhub?mcuId=' + row.mcuId + '&lang='+ this.$i18n.locale
      open(this.$router.resolve(url).href, '_blank');
    },
    findDeviceType1 () { // 判定该用户有哪些设备类型
      findDeviceType().then((res) => {
        console.log('客户包含设备类型：', res)
        if (res.resultCode == 1001) {
          if (res.resultModel && res.resultModel != '') {
            // this.isShowYHUB = true
            this.isShowLithium = res.resultModel.indexOf('e') > -1
          }
        }
      })
    },
    yhubQueryList () {
      var param = {
        companyIdList: this.selectCompany,
        key: this.tableObj.deviceName,
        pageNum: this.listQuery1.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery1.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.isShowLoading = true
      findBatteryDeviceWeekList(param).then(res => {
        if (res.resultCode == 1001) {
          console.log('YHUB周报：', res)
          this.isShowLoading = false
          this.listQuery1.pageInfo.total = res.resultModel.total // 分页
          if (!res.resultModel) return
          var list = res.resultModel.list || []
          this.yhubTableData = []
          // list[1].weekReport.splice(0, 2)
          list.forEach(v => {
            if (v.weekReport && v.weekReport.length >= 1) {
              var weekOption = []
              v.weekReport.forEach(m => {
                weekOption.push({
                  label: this.$t('report.first') + m.week + this.$t('report.week') + getDateAndHour(m.startTime, 'noTime') + '-' + getDateAndHour(m.endTime, 'noTime'),
                  // key: m.week,
                  key: m.startTime,
                  startTime: m.startTime,
                  endTime: m.endTime
                })
              })

              this.yhubTableData.push({
                deviceName: v.deviceName,
                chargedah: v.weekReport[0].chargedAh ? v.weekReport[0].chargedAh : '--',
                usedah: v.weekReport[0].dischargedAh ? v.weekReport[0].dischargedAh : '--',
                warningAccount: (v.weekReport[0].warn || v.weekReport[0].warn == 0) ? v.weekReport[0].warn : '--',
                weekOptions: weekOption,
                weekId: v.weekReport[0].startTime,
                weekList: v.weekReport,
                mcuId: v.mcuId,
                sn: v.deviceSn
              })
            } else {
              this.yhubTableData.push({
                deviceName: v.deviceName,
                chargedah: '--',
                usedah: '--',
                warningAccount: '--',
                weekOptions: [],
                mcuId: v.mcuId,
                sn: v.deviceSn
              })
            }
          })
        }
        // this.yhubTableData
      })
    },
    lithiumQueryList () { // 选项卡--lithium初始化
      var param = {
        companyIdList: this.selectCompany,
        key: this.tableObj.deviceName,
        pageNum: this.listQuery2.pageInfo.pageNum, // 分页--选中某一页
        pageSize: this.listQuery2.pageInfo.pageSize // 分页--每一页的列表的行数 10 20 50
      }
      this.isShowLoading = true
      findLithiumDeviceWeekList(param).then(res => {
        if (res.resultCode == 1001) {
          this.isShowLoading = false
          this.listQuery2.pageInfo.total = res.resultModel.total // 分页
          if (!res.resultModel) return
          var lithiumList = res.resultModel.list || []
          this.lithiumTableData = []
          // list[1].weekReport.splice(0, 2)
          lithiumList.forEach(v => {
            if (v.weekReport && v.weekReport.length >= 1) {
              var weekOption = []
              v.weekReport.forEach(m => {
                weekOption.push({
                  label: this.$t('report.first') + m.week + this.$t('report.week') + getDateAndHour(m.startTime, 'noTime') + '-' + getDateAndHour(m.endTime, 'noTime'),
                  key: m.startTime,
                  startTime: m.startTime,
                  endTime: m.endTime
                })
              })
              this.lithiumTableData.push({
                deviceName: v.deviceName,
                chargedah: v.weekReport[0].chargedAh ? v.weekReport[0].chargedAh : '--',
                usedah: v.weekReport[0].dischargedAh ? v.weekReport[0].dischargedAh : '--',
                warningAccount: (v.weekReport[0].warn || v.weekReport[0].warn == 0) ? v.weekReport[0].warn : '--',
                weekOptions: weekOption,
                weekId: v.weekReport[0].startTime,
                weekList: v.weekReport,
                mcuId: v.mcuId,
                sn: v.deviceSn
              })
            } else {
              this.lithiumTableData.push({
                deviceName: v.deviceName,
                chargedah: '--',
                usedah: '--',
                warningAccount: '--',
                weekOptions: []
              })
            }
          })
        }
        // this.yhubTableData
      })
    },
    // 筛选改变事件
    changeSearch () {
      if (this.tableObj.deviceName) {
        // 去掉首尾空格
        this.tableObj.deviceName = this.tableObj.deviceName.replace(/(^\s*)|(\s*$)/g, '').replace(/(^\&nbsp\;*)|(\&nbsp\;*$)/g, '').replace(/(^\s*)|(\s*$)/g, '')
      }
      this.selectCompany = []
      this.selectCompany2.forEach(v => {
        this.selectCompany.push((typeof v === 'string' && v.indexOf('ID') > -1) ? v.slice(2) : v)
      })
      if (this.activeDevice == 'Yhub') {
        this.yhubTableData = []
        this.listQuery1.pageInfo.pageNum = 1
        this.pageshow1 = false
        this.yhubQueryList()
        this.$nextTick(() => {
          this.pageshow1 = true
        })
      } else if (this.activeDevice == 'Lithium') {
        this.lithiumTableData = []
        this.listQuery2.pageInfo.pageNum = 1
        this.pageshow2 = false
        this.lithiumQueryList()
        this.$nextTick(() => {
          this.pageshow2 = true
        })
      }
    },
    changeSearchWeek (row, index) {
      row.weekList.forEach(m => {
        if (m.startTime == row.weekId) {
          if (this.activeDevice == 'Yhub') {
            this.yhubTableData[index].chargedah = m.chargedAh ? m.chargedAh : '--'
            this.yhubTableData[index].usedah = m.dischargedAh ? m.dischargedAh : '--'
            this.yhubTableData[index].warningAccount = m.warn ? m.warn : '--'
          } else {
            this.lithiumTableData[index].chargedah = m.chargedAh ? m.chargedAh : '--'
            this.lithiumTableData[index].usedah = m.dischargedAh ? m.dischargedAh : '--'
            this.lithiumTableData[index].warningAccount = m.warn ? m.warn : '--'
          }
        }
      })
    },
    goToYhubDetail (row, type) {
      console.log(row)
      var weekReportInfo = {}
      row.weekOptions.forEach(v => {
        if (v.key == row.weekId) {
          weekReportInfo.type = type
          weekReportInfo.startTime = v.startTime
          weekReportInfo.endTime = v.endTime
          weekReportInfo.week = row.weekId
          weekReportInfo.deviceName = row.deviceName
          weekReportInfo.chargedah = row.chargedah
          weekReportInfo.usedah = row.usedah
          weekReportInfo.warningAccount = row.warningAccount
        }
      })
      sessionStorage.setItem('weekReportInfo', JSON.stringify(weekReportInfo))
      var routeData
      if (type == 'yhub') {
        routeData = this.$router.resolve({
          // path: '/report/reportYhubDetail',
          path: '/report/reportDetail',
          query: {
            type: 'Yhub',
            mcuId: row.mcuId,
            sn: row.sn
          }
        })
      } else {
        routeData = this.$router.resolve({
          // path: '/report/lithiumChartPage',
          path: '/report/reportDetail',
          query: {
            type: 'Lithium',
            mcuId: row.mcuId,
            sn: row.sn
          }
        })
      }

      window.open(routeData.href, '_self')
    },
    // 分页----start
    handleSizeChange1 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery1.pageInfo.pageSize = val
      this.yhubQueryList()
    },
    handleCurrentChange1 (val, e) {
      // 选中某一页
      this.listQuery1.pageInfo.pageNum = val
      this.yhubQueryList()
    },
    // 分页----end
    // 分页----start
    handleSizeChange2 (val, e) {
      // 每一页的列表的行数 10 20 50
      this.listQuery2.pageInfo.pageSize = val
      this.lithiumQueryList()
    },
    handleCurrentChange2 (val, e) {
      // 选中某一页
      this.listQuery2.pageInfo.pageNum = val
      this.lithiumQueryList()
    }

  }
}
</script>

<style lang="scss" scoped>
.recordRow {
  display: flex;
  justify-content: space-around;
  align-items: center;
  padding: 10px 0;
}
.recordRow > div {
  text-align: center;
  width: 25%;
}
.recordRow > div p {
  line-height: 1.4em;
}
.myTable {
  border-collapse: collapse;
  width: 100%;
  border: 1px solid #e6e9ed;
  font-size: 14px;
  color: #606266;
  th {
    color: #909399;
    padding: 0 10px;
  }
  td {
    text-align: center;
    padding: 0 10px;
  }
  .infoP {
    font-size: 1.2em;
    font-weight: bold;
  }
}
.loading {
  position: absolute;
  width: 100%;
  height: 100%;
  background: #fffffff0;
  color: #1990fc;
  z-index: 99;
  text-align: center;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
<style lang="scss">
#reportIndex {
  background: #fff;
  #tableWarp .el-input-group {
    width: 40% !important;
    max-width: 400px !important;
    margin-top: 13px;
  }
  #tableWarp .filter-container .filter-item {
    margin-bottom: 0px;
  }
  .recordRow {
    display: flex;
    justify-content: space-around;
    align-items: center;
    padding: 10px 0;
  }
  .recordRow > div {
    text-align: center;
    width: 25%;
  }
  .recordRow > div p {
    line-height: 1.4em;
  }
  .myTable {
    // border-collapse: collapse;
    // width: 100%;
    // border: 1px solid #e6e9ed;
    // font-size: 14px;
    // color: #606266;
    // th {
    //   color: #909399;
    //   padding: 0 10px;
    // }
    // td {
    //   text-align: center;
    //   padding: 0 10px;
    // }
    .infoP {
      font-size: 1.2em;
      font-weight: bold;
    }
  }
  .loading {
    position: absolute;
    width: 100%;
    height: 100%;
    background: #fffffff0;
    color: #1990fc;
    z-index: 99;
    text-align: center;
    display: flex;
    justify-content: center;
    align-items: center;
  }
}
</style>
